// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__2XIHU","button":"Pill_button__PiT55","icon":"Pill_icon__32sIf","show":"Pill_show__26Xhs"};